type IconProps = {
  color?: string
  className?: string
}

const HDILogo: React.FC<IconProps> = ({ color = 'currentColor', ...attributes }) => {
  return (
    <svg width="150" height="60" viewBox="0 0 75 30" fill={color} xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <g fill="#fff" fillRule="nonzero">
        <path d="M44.2 29.8H33.3V0h11.3c2.6 0 5.2.3 7.7 1 2 .6 3.9 1.6 5.5 3 1.4 1.3 2.4 2.9 3.2 4.6.8 1.9 1.1 3.9 1.1 6v.1c.2 4.1-1.5 8.1-4.5 10.8-1.6 1.4-3.5 2.5-5.6 3.1-2.5.9-5.1 1.3-7.8 1.2Zm-1.1-21.6v13.5h1.6c4.8 0 7.4-2.3 7.4-6.7v-.1c0-4.4-2.6-6.7-7.4-6.7h-1.6Z" />
        <path d="M64.5 0h9.8v29.8h-9.8zM0 0h9.8v29.8H0zM19.6 0h9.8v29.8h-9.8zM9.8 9.9h9.8v10H9.8z" />
      </g>
    </svg>
  )
}

export default HDILogo
